import { Theme } from '@mui/material/styles';

export const modal = {
    '& .MuiDialog-paper': {
        borderRadius: 0,
        boxShadow: 'none',
        maxWidth: '900px',
    },

    '& .MuiBackdrop-root': {
        backgroundColor: 'modalBackdrop.main',
    }
} as const;

export const title = (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'modalHeader.main',
    color: 'text.secondary',
    paddingLeft: theme.spacing(4.375),
    paddingRight: theme.spacing(1.875),
}) as const;

export const text = {
    fontSize: 22,
} as const;

export const close = {
    color: 'modalClose.main',
} as const;

export const content = (theme: Theme) => ({
    maxHeight: '515px',
    paddingX: `${theme.spacing(4.375)} !important`,
    paddingY: `${theme.spacing(3.125)} !important`,
    overflowY: 'scroll',
}) as const;
